import { JsEnum } from '@meta-vue/util'
// 呼叫类型
export const CALL_TYPE = [
  { id: '', value: '全部' },
  { id: '1', value: '电话呼入' },
  { id: '2', value: '电话外呼' },
  { id: '3', value: '手工创建' },
  { id: '4', value: '在线接待' },
  { id: '5', value: '在线主动接待' },
  { id: '6', value: '在线主动联系' },
  { id: '7', value: '任务外呼' },
  { id: '8', value: '电话呼入（avaya）' }
]

// 呼叫类型字典
export const CALL_TYPE_MAP = new JsEnum([
  ['电话呼入', 1, 'CALL_IN'],
  ['电话外呼', 2, 'CALL_OUT'],
  ['手工创建(模拟弹屏)', 3, 'MANUAL'],
  ['在线客服', 4, 'IM'],
  ['在线主动接待', 5, 'ONLINE_ACTIVE_RECEPTION'],
  ['在线主动联系', 6, 'ONLINE_ACTIVE_CONTACT'],
  ['任务外呼', 7, 'TASK_CALL'],
  ['电话呼入(avaya)', 8, 'CALL_IN_AVAYA'],
  ['意见反馈', 9, 'FEEDBACK']
])

export const CALLOUT_MESSAGE_TYPE = {
  GET_STATUS: 'getStatus', // 获取当前的通话状态
  STATUS_CHANGE: 'statusChange', // 状态改变
  CALL_DROP: 'drop', // 挂断
  HOLD: 'hold',
  UN_HOLD: 'unhold',
  ADD_CALL_LIST: 'addCallList', // 新增会话
  SET_CURR_TEL: 'setCurrTel', // 设置当前通话号码
  RECORD_SAVED: 'recordSaved', // 已保存小结单信息
  SET_CURR_CALL_ID: 'setCurrCallId', // 设置当前通话的callId
  USER_CONFIG_CHANGE: 'userConfigChange' // 用户配置改变
}

function defineEnumProperty(ctx) {
  return (prop, value) => {
    Object.defineProperty(ctx, prop, {
      configurable: false,
      writable: false,
      enumerable: true,
      value: value
    })
  }
}

function genMap(items, keyIdx, valIdx) {
  return items.reduce((obj, item) => {
    obj[item[keyIdx]] = item[valIdx]
    return obj
  }, {})
}

const valueIndex = 0
const labelIndex = 1
const codeIndex = 2
const defaultFieldMap = { label: 'label', value: 'value', code: 'code' }
class Enum {
  constructor(originItems) {
    this.originItems = originItems
    this.code2value = genMap(originItems, codeIndex, valueIndex)
    this.code2label = genMap(originItems, codeIndex, labelIndex)
    this.value2label = genMap(originItems, valueIndex, labelIndex)
  }

  addEnumValue() {
    const addEnumValueFn = defineEnumProperty(this)

    this.originItems.forEach((item, index) => {
      addEnumValueFn(item[codeIndex], item[valueIndex])
      // addEnumValue(`${item.code}.value`, item.value);
      // addEnumValue(`${item.code}.label`, item.label);
      // addEnumValue(`${item.code}.code`, item.code);
    })
  }

  getLabelByValue(key) {
    return this.value2label[key]
  }
  getValueByCode(key) {
    return this.code2value[key]
  }

  getLabelOptions(fieldMap) {
    fieldMap = { ...defaultFieldMap, ...fieldMap }
    return this.originItems.map(item => ({
      [fieldMap.label]: item[labelIndex],
      [fieldMap.value]: item[valueIndex]
    }))
  }
}

export const CALL_TYPE_ENUM = new Enum([
  ['', '全部', 'ALL'],
  ['1', '电话呼入', 'CALL_IN'],
  ['2', '电话外呼', 'CALL_OUT'],
  ['3', '手工创建', 'MANUAL'],
  ['4', '在线接待', 'IM'],
  ['7', '任务外呼', 'TASK_CALL'],
  ['8', '电话呼入（avaya）', 'CALL_IN_AVAYA'],
  ['9', '区域进线', 'REGION_CALL_IN']
])

// 通话状态
export const CALL_STATUS = {
  NONE: 'none', // 未开始
  START: 'start', // 开始
  END: 'end', // 结束
  RING: 'ring', // 振铃
  CALLING: 'calling', // 天润双呼呼叫客户中
  DOING: 'doing', // 接通
  HOLD: 'hold' // 保持
}
